export type TasksTab = 'board' | 'archive'

export interface TasksNavigationItem {
  id: TasksTab
  icon: string
  path: string
  translationKey: string
}

export const TASKS_NAVIGATION: TasksNavigationItem[] = [
  {
    id: 'board',
    icon: 'icon-tablero',
    path: '/tasks',
    translationKey: 'NAVIGATION:TasksBoard',
  },
  {
    id: 'archive',
    icon: 'icon-base_de_datos',
    path: '/tasks-archive',
    translationKey: 'NAVIGATION:TasksDataBase',
  },
]
